import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import "../../assets/css/scss/section/team/_teamImageTitleHoriz.scss";
import preventRightClick from "../../common/preventRightClick";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../interfaces/redux";
import { BASEBALL_TEAMS_LIST } from "../../constant/match";

export default function TeamImageTitleHoriz(props: any) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLang = globalState?.selectedLang || "";
  const clickOnButton = (redirect: any) => {
    if (redirect) {
      setRedirectUrl("/team/" + redirect);
    }
  };
  return (
    <div className="team-img-horiz">
      {redirectUrl ? <Redirect to={redirectUrl} /> : null}
      <Card>
        <div
          className="thumbnail-img position-relative"
          onContextMenu={(e) => preventRightClick(e)}
        >
          <Card.Img
            variant="top"
            src={
              props?.flag ||
              "https://res.cloudinary.com/deq61wdj1/image/upload/v1770574250/lcd/team_images/default-team-logo_pqvbz8.png"
            }
          />
          <h4 className="stoke text-uppercase">
            {props?.name ? props?.name : ""}
          </h4>
        </div>
        <Card.Body>
          <Card.Title className="bold text-uppercase">
            {props?.fullname}
          </Card.Title>
          <Card.Text className="font-14 line-clamp-4">
            {props?.team_overview}
          </Card.Text>
          <Button
            variant="primary"
            className="bold"
            onClick={() => clickOnButton(props?.identifier)}
          >
            {BASEBALL_TEAMS_LIST[selectedLang]["link_text"]}
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
}
